// CPD kpi
// API related actions
export const FETCHING_INVENTORY_STATUS = '@@toyota/FETCHING_INVENTORY_STATUS';
export const FETCHED_INVENTORY_STATUS = '@@toyota/FETCHED_INVENTORY_STATUS';
export const FETCHED_INVENTORY_STATUS_FAILED = '@@toyota/FETCHED_INVENTORY_STATUS_FAILED';
export const FETCHING_INVENTORY_STATUS_DETAIL = '@@toyota/FETCHING_INVENTORY_STATUS_DETAIL';
export const FETCHED_INVENTORY_STATUS_DETAIL = '@@toyota/FETCHED_INVENTORY_STATUS_DETAIL';
export const FETCHED_INVENTORY_STATUS_DETAIL_FAILED = '@@toyota/FETCHED_INVENTORY_STATUS_DETAIL_FAILED';
export const FETCHING_LINES_INFO = '@@toyota/FETCHING_LINES_INFO';
export const FETCHED_LINES_INFO = '@@toyota/FETCHED_LINES_INFO';
export const FETCHED_LINES_INFO_FAILED = '@@toyota/FETCHED_LINES_INFO_FAILED';
export const FETCHING_LINES_INFO_WITH_DETAIL = '@@toyota/FETCHING_LINES_INFO_WITH_DETAIL';
export const FETCHED_LINES_INFO_WITH_DETAIL = '@@toyota/FETCHED_LINES_INFO_WITH_DETAIL';
export const FETCHED_LINES_INFO_WITH_DETAIL_FAILED = '@@toyota/FETCHED_LINES_INFO_WITH_DETAIL_FAILED';
export const DOWNLOADING_LINES_FILE = '@@toyota/DOWNLOADING_LINES_FILE';
export const DOWNLOADED_LINES_FILE = '@@toyota/DOWNLOADED_LINES_FILE';
export const DOWNLOADED_LINES_FILE_FAILED = '@@toyota/DOWNLOADED_LINES_FILE_FAILED';

// Complementary actions
export const CLEAR_LINES_INFO = '@@toyota/CLEAR_LINES_INFO';
export const CLEAR_URL_LINES_FILE = '@@toyota/CLEAR_URL_LINES_FILE';

// Sales Kpi
// API related actions
export const FETCHING_LATEST_SALES = '@@toyota/FETCHING_LATEST_SALES';
export const FETCHED_LATEST_SALES = '@@toyota/FETCHED_LATEST_SALES';
export const FETCHED_LATEST_SALES_FAILED = '@@toyota/FETCHED_LATEST_SALES_FAILED';
export const FETCHING_SALES_AND_BUDGETS = '@@toyota/FETCHING_SALES_AND_BUDGETS';
export const FETCHED_SALES_AND_BUDGETS = '@@toyota/FETCHED_SALES_AND_BUDGETS';
export const FETCHED_SALES_AND_BUDGETS_FAILED = '@@toyota/FETCHED_SALES_AND_BUDGETS_FAILED';
export const FETCHING_SALES_BY_DEALER = '@@toyota/FETCHING_SALES_BY_DEALER';
export const FETCHED_SALES_BY_DEALER = '@@toyota/FETCHED_SALES_BY_DEALER';
export const FETCHED_SALES_BY_DEALER_FAILED = '@@toyota/FETCHED_SALES_BY_DEALER_FAILED';

// Complementary actions
export const CLEAR_SALES = '@@toyota/CLEAR_SALES';

// Part Watching Kpi
// API related actions
export const FETCHING_PART_WATCHING = '@@toyota/FETCHING_PART_WATCHING';
export const FETCHED_PART_WATCHING = '@@toyota/FETCHED_PART_WATCHING';
export const FETCHED_PART_WATCHING_FAILED = '@@toyota/FETCHED_PART_WATCHING_FAILED';
export const FETCHING_SALES_BY_YEAR_AND_MONTH = '@@toyota/FETCHING_SALES_BY_YEAR_AND_MONTH';
export const FETCHED_SALES_BY_YEAR_AND_MONTH = '@@toyota/FETCHED_SALES_BY_YEAR_AND_MONTH';
export const FETCHED_SALES_BY_YEAR_AND_MONTH_FAILED = '@@toyota/FETCHED_SALES_BY_YEAR_AND_MONTH_FAILED';
export const FETCHING_ON_ORDERS_BY_YEAR_AND_MONTH = '@@toyota/FETCHING_ON_ORDERS_BY_YEAR_AND_MONTH';
export const FETCHED_ON_ORDERS_BY_YEAR_AND_MONTH = '@@toyota/FETCHED_ON_ORDERS_BY_YEAR_AND_MONTH';
export const FETCHED_ON_ORDERS_BY_YEAR_AND_MONTH_FAILED = '@@toyota/FETCHED_ON_ORDERS_BY_YEAR_AND_MONTH_FAILED';
export const FETCHING_RECEPTIONS_ORDERS_BY_YEAR_AND_MONTH = '@@toyota/FETCHING_RECEPTIONS_ORDERS_BY_YEAR_AND_MONTH';
export const FETCHED_RECEPTION_ORDERS_BY_YEAR_AND_MONTH = '@@toyota/FETCHED_RECEPTION_ORDERS_BY_YEAR_AND_MONTH';
export const FETCHED_RECEPTION_ORDERS_BY_YEAR_AND_MONTH_FAILED =
    '@@toyota/FETCHED_RECEPTION_ORDERS_BY_YEAR_AND_MONTH_FAILED';

// Complementary actions
export const CHANGE_PART_WATCHING_LIST_PAGE = '@@toyota/CHANGE_PART_WATCHING_LIST_PAGE';
export const CHANGE_PART_WATCHING_LIST_PAGE_SIZE = '@@toyota/CHANGE_PART_WATCHING_LIST_PAGE_SIZE';
export const CLEAR_PART_WATCHING = '@@toyota/CLEAR_PART_WATCHING';


// Search Param
export const SET_SEARCH_PARAM_DETAIL = '@@toyota/SET_SEARCH_PARAM_DETAIL';
export const CLEAR_SEARCH_PARAM_DETAIL = '@@toyota/SET_SEARCH_PARAM_DETAIL';
